<span [id]="id">
  @if (hasErrors()) {
    @for (error of getErrors(); track error) {
      <span class="error">{{ error }}</span>
    }
  }
</span>
